module.exports = __webpack_public_path__ + "img/img7.102436b7.jpg";